import React, {Component} from 'react'

import PaperBlock from "./../../../ui/PaperBlock"
import Button from '@material-ui/core/Button'
import FormGroup from '@material-ui/core/FormGroup'
import TextField from '@material-ui/core/TextField'

/**
 * <CommentPanel comment onUpdate={comment} />
 */

class CommentPanel extends Component {

  state = {
    comment: '',
  }

  componentDidMount() {
    this.setState({
      comment: this.props.comment || ''
    })
  }

  componentDidUpdate(prevProps) {
    if (prevProps.comment !== this.props.comment) {
      this.setState({
        comment: this.props.comment,
      })
    }
  }

  render() {
    return <PaperBlock>
      <FormGroup>

        <TextField
          label = "Комментарий к шоу"
          multiline
          rowsMax = "8"
          value = {this.state.comment}
          onChange = {e => {
            this.setState({
              comment: e.target.value
            })
          }}
          margin = "normal"
          variant = "outlined"
        />

        <Button
          onClick={e => {
            e.stopPropagation()
            if (typeof this.props.onUpdate === 'function') {
              this.props.onUpdate(this.state.comment)
            }
          }}
        >Обновить комментарий</Button>

      </FormGroup>
    </PaperBlock>
  }

}

export default CommentPanel
